import React from "react";
import { Alert } from "antd";
import { Icon } from "Components";

interface CampaignLimitToastProps {
  visible: boolean;
  message: string;
  onClose: () => void;
}

const CampaignLimitToast: React.FC<CampaignLimitToastProps> = ({
  visible,
  message,
  onClose,
}) => {
  if (!visible) return null;

  return (
    <Alert
      message={message}
      type="warning"
      showIcon
      closable
      onClose={onClose}
      icon={<Icon type="phishingManagerWarningModalPrefix" />}
      closeText={
        <div className="pm-icon-size">
          <Icon type="phishingManagerWarningModalClose" />
        </div>
      }
      className="campaign-limit-toast"
    />
  );
};

export default CampaignLimitToast;
